import { MONITOR_RECEIVE } from '../Actions/Monitor.action';

const defaultState = {
    list: [],
    errors: {},
}

export const monitor = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case MONITOR_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        default:
            return state;
    }
}